module.exports = __webpack_public_path__ + "img/parner.755e2067.png";